import * as Tone from 'tone';

const _createOsc = (freq, pan, vol, partials) => {
  const panner = new Tone.Panner3D(Math.random(), Math.random(), Math.random());
  const osc = new Tone.Oscillator(freq, 'sine').connect(panner).toDestination();
  osc.volume.value = -100;
  osc.partials = partials;

  return { 'osc': osc, 'params': { 'volume': vol } };
}

const SILENCE = -100;
const FADE_IN = 3;
const FADE_OUT = 3;

export class Sonification {

  constructor(embedding = { 'token': '', 'embedding': [] }) {
    console.log('constructor:', embedding);

    this.playing = false;
    this.tokenLoopCallback = null;

    this.setEmbedding(embedding);
    // this.updateOscillators();
  }

  startAudio() {
    console.log("startAudio()");
    Tone.start();
  }

  startTokenLoop() {
    const voices = speechSynthesis.getVoices();
    const voiceId = 8;
    const callback = () => {
      const msg = new SpeechSynthesisUtterance();
      msg.voice = voices[voiceId];
      msg.volume = 0.7;
      msg.rate = 0.5;
      msg.pitch = 0.7;
      msg.lang = "en";
      msg.text = this.token;
      speechSynthesis.speak(msg);
    }

    if (this.tokenLoopCallback) {
      clearInterval(this.tokenLoopCallback);
      this.tokenLoopCallback = null;
    }
    this.tokenLoopCallback = setInterval(callback, FADE_IN * 15 * 1000);
  }

  updateOscillators() {
    const embedding = this.embedding;
    const len = embedding.length;

    const partitionIndex = parseInt(8+(len-8)/2)

    console.log('updateOscillators():', embedding);


    // const mainFreq = embedding.length > 0 ? parseInt(((embedding[500]+1)/2)*90) : 40;
    const mainFreq = embedding.length > 0 ? 20 + ((((embedding[500]+1)/2)*100)%10)/10 * 100 : 40;
    console.log(`len: ${embedding.length}, 100th embedding: ${embedding[500]}, mainFreq: ${mainFreq}, token: ${this.token}`);

    this.oscillators = [
     // main tone
     _createOsc(mainFreq, -1, -12, embedding.slice(0,4)),
     _createOsc(mainFreq+5, 1, -12, embedding.slice(4, 8)),

     // embedding low
     _createOsc(60, -1, -48, embedding.slice(8, partitionIndex)),
     _createOsc(62, 1, -48, embedding.slice(partitionIndex, len)),
   ];

   this.start();
  }

  setEmbedding(embedding) {
    this.embedding = embedding.embedding;
    this.token = embedding.token;

    console.log(`Set embedding to`, this.token, embedding.token);
    this.updateOscillators();
  }


  start() {
    console.log("Start");
    for (let oscillator of this.oscillators) {
      const osc = oscillator.osc;
      const params = oscillator.params;

      osc.start();
      osc.volume.rampTo(params.volume, FADE_IN);
      this.playing = true;
    }
    // this.startTokenLoop();
  }

  stop() {
    console.log('Stop');
    if (this.tokenLoopCallback) clearInterval(this.tokenLoopCallback);

    for (let i=0; i<this.oscillators.length; ++i) {
      const osc = this.oscillators[i].osc;

      osc.volume.rampTo(SILENCE, FADE_OUT);
    }

    const self = this;
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        for(let oscillator of this.oscillators) oscillator.osc.stop();
        resolve();
        self.playing = false;
      }, FADE_OUT*1000)
    });
  }

  toggle() {
    if (this.playing) this.stop();
    else this.start();
  }
}
